import {lazy} from '@aboutyou/lazy-imports';
import {useLogHydrationFailed} from '@aboutyou/logic-components';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

const LoadingSkeletonWithHydrationFailedLogging: React.FC = () => {
  useLogHydrationFailed({context: 'ADPPageSkeleton'});
  return <LoadingPageSpinner />;
};

export const ArticleDetail = lazy(
  () =>
    import('./ArticleDetail.eager').then(mod => ({default: mod.ArticleDetail})),
  {
    fallback: <LoadingSkeletonWithHydrationFailedLogging />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
